module.exports = __webpack_public_path__ + "img/11oz-Mug.6c72f80f.svg";